<template>
    <div class="note-editor">
        <div ref="editor"></div>
    </div>
</template>

<script>
    import Quill from 'quill';
    import 'quill/dist/quill.snow.css';

    export default {
        name: 'NoteEditor',
        props: {
            value: {type: String, default: ''}
        },
        data: function() {
            return {
                quill: null
            };
        },
        mounted() {
            this.quill = new Quill(this.$refs.editor, {
                theme: 'snow',
                placeholder: 'Write your note...',
                modules: {
                    toolbar: [
                        [{header: [1, 2, 3, false]}],
                        ['bold', 'italic', 'underline'],
                        [{list: 'ordered'}, {list: 'bullet'}],
                        ['link'],
                        ['clean']
                    ]
                }
            });
            if (this.value) this.quill.root.innerHTML = this.value;
            this.quill.on('text-change', () => {
                this.$emit('input', this.quill.root.innerHTML);
            });
        },
        beforeDestroy() {
            this.quill = null;
        },
        watch: {
            value: function(val) {
                // Typing round-trips through the input event with an identical
                // string, so only an external change (switching notes) lands here.
                if (this.quill && (val || '') !== this.quill.root.innerHTML) {
                    this.quill.root.innerHTML = val || '';
                }
            }
        }
    };
</script>

<style scoped>
    .note-editor >>> .ql-container {
        font-size: 1rem;
    }
    /* Height goes on the editable area itself so clicking anywhere in the
       box focuses the editor, not just the first line */
    .note-editor >>> .ql-editor {
        min-height: 300px;
    }
    .note-editor >>> .ql-toolbar {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .note-editor >>> .ql-container {
        border-bottom-left-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
    }
</style>
